import get from "lodash/get"

// Позволяет забрать из стора статусную модель
export const selectStatus = state => {
  return get(state, `status`)
}

export const selectAllStatus = state => {
  return {
    data: get(state, `status.all`),
    status: get(state, `status.allStatus`),
  }
}
